// Chart.js is ~200KB and only the author/manager dashboards use it, so it's
// loaded on demand rather than bundled into the main entry point.
let chartPromise = null;

window.ttNormalizeCompanyName = function (company) {
    const name = (company || '').trim().replace(/\s+/g, ' ');
    if (!name) return { key: 'not provided', label: 'Not provided' };

    const key = name.toLocaleLowerCase().replace(/\.$/, '');
    if (key === 'fanuc' || key === 'fanuc corporation') {
        return { key: 'fanuc', label: 'FANUC' };
    }

    return { key, label: name.replace(/^fanuc\b\s+(\p{L})/iu, (_match, firstLetter) => `FANUC ${firstLetter.toLocaleUpperCase()}`) };
};

function loadChart() {
    if (!chartPromise) {
        chartPromise = import('chart.js/auto').then((module) => module.default);
    }

    return chartPromise;
}

// Re-rendering the same canvas (e.g. after a date-range change) must destroy the
// previous instance first, or Chart.js throws "Canvas is already in use".
window.ttChart = async function (canvas, config) {
    if (!canvas) {
        return null;
    }

    const Chart = await loadChart();

    if (canvas._ttChart) {
        canvas._ttChart.destroy();
    }

    canvas._ttChart = new Chart(canvas, config);

    return canvas._ttChart;
};
